export const categories = [
  { slug: 'riman', name: '日漫精选', icon: 'ri-sun-line', description: '日本动漫最新番剧与经典作品合集' },
  { slug: 'guoman', name: '国漫之光', icon: 'ri-china-railway-line', description: '国产动漫优秀作品一览' },
  { slug: 'juchang', name: '剧场版', icon: 'ri-film-line', description: '动漫电影剧场版精选' },
  { slug: 'jingdian', name: '经典回顾', icon: 'ri-vidicon-line', description: '那些年我们追过的经典动画' },
  { slug: 'rexue', name: '热血战斗', icon: 'ri-fire-line', description: '燃到爆的热血战斗番合集' },
  { slug: 'lianai', name: '恋爱日常', icon: 'ri-heart-line', description: '甜蜜治愈的恋爱与日常番' },
  { slug: 'kehuan', name: '科幻奇幻', icon: 'ri-rocket-line', description: '脑洞大开的科幻与奇幻世界' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line', description: '烧脑刺激的悬疑推理番' },
];

export const categoryMap: Record<string, { name: string; icon: string; description: string }> = {};
categories.forEach((c) => {
  categoryMap[c.slug] = { name: c.name, icon: c.icon, description: c.description };
});